import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';
import { modal } from '../../../components/Base/Modal';

// GET WITHDRAWALS
function* getWallets({ payload }) {
  try {
    const { data, status } = yield call(api.wallets.getWallets, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_HOT_WALLETS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_HOT_WALLETS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// UPDATE WALLETS MIN MAX
function* updateHotAutoTransfer({ payload }) {
  try {
    const { status } = yield call(api.wallets.updateTransfer, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.UPDATE_HOT_WALLETS_SUCCESS });
    yield put({ type: types.GET_HOT_WALLETS_START });
  } catch (error) {
    yield put({ type: types.UPDATE_HOT_WALLETS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// GET WALLET ADDRES
function* getWalletAddres({ payload }) {
  try {
    const { data, status } = yield call(api.wallets.getAddres, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_WALLET_ADDRES_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_WALLET_ADDRES_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

// TRANSFER TO COLD
function* transferToCold({ payload }) {
  try {
    const { status } = yield call(api.wallets.transfetToCold, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.TRANSFER_TO_COLD_SUCCESS });
    notification({ type: 'success', message: 'Success' });
    modal.close();
  } catch (error) {
    yield put({ type: types.TRANSFER_TO_COLD_FAILURE });
    if (error?.response?.status === 401) return;

    if (error?.response?.data?.errors.includes('not_enough_money')) {
      notification({ type: 'error', message: 'Not enough money' });
    }
    if (error?.response?.data?.errors.includes('transaction_amount_too_small')) {
      notification({ type: 'error', message: 'Transaction amount too small' });
    }
    if (error?.response?.status === 500) {
      notification({ type: 'error', message: 'Client error' });
    }
  }
}

export function* hotWallets() {
  yield all([
    takeLatest(types.GET_HOT_WALLETS_START, getWallets),
    takeLatest(types.UPDATE_HOT_WALLETS_START, updateHotAutoTransfer),
    takeLatest(types.GET_WALLET_ADDRES_START, getWalletAddres),
    takeLatest(types.TRANSFER_TO_COLD_START, transferToCold),
  ]);
}
